<template>
  <b-link :class="btn_class" class="show-more-btn" :to="path">
    <span>Voir plus</span>
    <i class="mdi mdi-arrow-right"></i>
  </b-link>
</template>

<script>
export default {
  props: ["path","btn_class"],
  components: {},
  name: "SeeMoreBtn",
};
</script>
<style scoped lang="css">
</style>
